export const UPLOAD_BUTTONS_GAS_P_CONFIG = [
  'peticion_gasp',
  'escritura_poderes',
  'dn',
  'cc',
  'proyecto_gas',
  'proyecto_calefaccion',
]
